import React from 'react'
import {Heading, FontWeight, HeadingElement} from '@influxdata/clockface'

interface Props {
  text: string
}

const FunnelHeader = ({text}: Props): JSX.Element => (
  <Heading
    element={HeadingElement.H1}
    weight={FontWeight.Regular}
    className="cf-funnel-page--title"
  >
    {text}
  </Heading>
)

export default FunnelHeader
